
import { useEffect } from 'react';
import { initializeAnalytics, disableAnalytics, hasConsentFor } from '@/utils/cookieConsent';

interface GoogleAnalyticsProps {
  measurementId?: string;
}

export const GoogleAnalytics = ({ measurementId }: GoogleAnalyticsProps) => {
  useEffect(() => {
    if (!measurementId) {
      return;
    }

    const handleConsentUpdate = () => {
      if (hasConsentFor('analytics')) {
        initializeAnalytics(measurementId);
      } else {
        disableAnalytics();
      }
    };

    // Listen for cookie consent updates
    window.addEventListener('cookieConsentUpdated', handleConsentUpdate);

    // Initialize on mount if consent already given
    handleConsentUpdate();

    return () => {
      window.removeEventListener('cookieConsentUpdated', handleConsentUpdate);
    };
  }, [measurementId]);

  return null;
};
